import { render, staticRenderFns } from "./SamInteractiveLabel.vue?vue&type=template&id=80cc367c&scoped=true&shadow"
import script from "./SamInteractiveLabel.vue?vue&type=script&lang=js&shadow"
export * from "./SamInteractiveLabel.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamInteractiveLabel.vue?vue&type=style&index=0&id=80cc367c&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "80cc367c",
  null
  ,true
)

export default component.exports